import React, { useEffect, useState } from "react";
import fetchWrapper from "../../api/fetchWrapper";
import { API_URL } from "../../Config/Config";
import AgGridTable from "../AgGridTable";
import { Card, CardBody } from "reactstrap";
import { thousandSeparator } from "../../api/helper";

const StationaryCombustion = () => {
    const [data, setData] = useState([]);

    const getStationaryFactors = async () => {
        await fetchWrapper(`${API_URL}/emissionunits/StationaryCombustion`)
            .then((res) => {
                console.log(res.json)
                setData(res.json)
            }, (err) => console.log(err))
    }

    useEffect(() => {
        getStationaryFactors()
    }, [])

    const columns = [
        {
            headerName: 'Fuel Type',
            field: 'sourceDescription',
            editable: true,
            filter: false,
            flex: 2,
            autoHeight: true,
            wrapText: true,
            sortable: false,
            cellClass: 'cell-wrap'
        },
        {
            headerName: 'Fuel State',
            field: 'itemType',
            editable: true,
            filter: false,
            flex: 1,
            autoHeight: true,
            wrapText: true,
            sortable: false
        },
        {
            headerName: 'Unit',
            field: 'uiUnit',
            editable: true,
            filter: false,
            flex: 1,
            autoHeight: true,
            wrapText: true,
            sortable: false
        },
        {
            headerName: 'Country',
            field: 'countryCode',
            editable: true,
            filter: false,
            flex: 1,
            autoHeight: true,
            wrapText: true,
            sortable: false
        },
        {
            headerName: 'CO\u2082 Factor',
            field: 'co2FactorUnit',
            editable: true,
            filter: false,
            flex: 1,
            autoHeight: true,
            wrapText: true,
            sortable: false,
            isPinnedRight: true,
            cellRenderer: (params) => {
                return <div className="text-right w-70px">{params?.data?.co2FactorUnit ?
                    thousandSeparator(params?.data?.co2FactorUnit.toFixed(2)) : ''}</div>;
            }
        },
        {
            headerName: 'CH\u2084 Factor',
            field: 'ch4FactorUnit',
            editable: true,
            filter: false,
            flex: 1,
            autoHeight: true,
            wrapText: true,
            sortable: false,
            cellRenderer: (params) => {
                return <div className="text-right w-70px">{params?.data?.ch4FactorUnit ?
                    thousandSeparator(params?.data?.ch4FactorUnit.toFixed(2)) : ''}</div>;
            },
        },
        {
            headerName: 'N\u2082O Factor',
            field: 'n2oFactorUnit',
            editable: true,
            filter: false,
            flex: 1,
            autoHeight: true,
            wrapText: true,
            sortable: false,
            cellRenderer: (params) => {
                return <div className="text-right w-70px">{params?.data?.n2oFactorUnit ?
                    thousandSeparator(params?.data?.n2oFactorUnit.toFixed(2)) : ''}</div>;
            },
        },
    ]

    return (
        <div>
            <Card>
                <CardBody className="pad-10">
                    <div className="factor-table">
                        <div className="ag-theme-material ag-style" style={{ width: '100%' }}>
                            <AgGridTable
                                columnData={columns}
                                tableData={data}
                                paginationSize={10}
                            // agRef={groupsRef}
                            // onGridReady={onGridReady}
                            />
                        </div>
                    </div>
                </CardBody>
            </Card>

        </div>
    )
}

export default StationaryCombustion;